(() => {
  const BFMVideoCardsSwiper = () => {
    const selectors = {
      component: "bfm-video-cards",
    };

    const isSwiper = () => window.innerWidth < 1023;
    const swiperInstances = new WeakMap();

    const toggleSwiperClasses = () => {
      const parentElement = Array.from(document.getElementsByClassName(selectors.component));

      parentElement.forEach((element) => {
        const swiperContainer = element.querySelector(".bfm-video-cards__swiper");
        const wrapper = swiperContainer?.querySelector(".bfm-video-cards__wrapper");
        const slides = swiperContainer?.querySelectorAll(".bfm-video-cards__item");

        if (!swiperContainer || !wrapper || !slides) {
          return;
        }

        const currentSwiper = swiperInstances.get(swiperContainer);

        if (isSwiper()) {
          if (!currentSwiper) {
            swiperContainer.classList.add("swiper");
            wrapper.classList.add("swiper-wrapper");
            slides.forEach((slide) => slide.classList.add("swiper-slide"));

            const swiperInstance = new window.Swiper(swiperContainer, {
              slidesPerView: 1,
              freeMode: false,
              loop: false,
              navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
              },
            });

            swiperInstances.set(swiperContainer, swiperInstance);
          }
        } else {
          if (currentSwiper) {
            currentSwiper.destroy(true, true);
            swiperInstances.delete(swiperContainer);
          }

          swiperContainer.classList.remove("swiper");
          wrapper.classList.remove("swiper-wrapper");
          slides.forEach((slide) => slide.classList.remove("swiper-slide"));
        }
      });
    };
    document.addEventListener("DOMContentLoaded", toggleSwiperClasses);
    window.addEventListener("resize", toggleSwiperClasses);
  };

  BFMVideoCardsSwiper();
})();
